(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abrash-appointment"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-appointment]').forEach((section) => {
    const dateInput = section.querySelector('[data-appointment-date]');
    const timeSelect = section.querySelector('[data-appointment-time]');
    const message = section.querySelector('[data-date-message]');
    if (!dateInput || !timeSelect) return;

    const dubaiParts = () => {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const get = (type) => parts.find((part) => part.type === type).value;
      return { year: Number(get('year')), month: Number(get('month')), day: Number(get('day')) };
    };
    const formatDate = (date) => `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
    const current = dubaiParts();
    const minDate = new Date(Date.UTC(current.year, current.month - 1, current.day));
    const maxDate = new Date(minDate);
    maxDate.setUTCDate(maxDate.getUTCDate() + 30);
    dateInput.min = formatDate(minDate);
    dateInput.max = formatDate(maxDate);

    const slots = [];
    for (let hour = 8; hour < 17; hour += 1) {
      if (hour !== 13) {
        slots.push(`${String(hour).padStart(2, '0')}:00`);
        slots.push(`${String(hour).padStart(2, '0')}:30`);
      }
    }

    const refreshTimes = () => {
      timeSelect.innerHTML = '<option value="">Select a time</option>';
      message.textContent = '';
      timeSelect.disabled = true;
      if (!dateInput.value) return;
      const selectedDate = new Date(`${dateInput.value}T00:00:00+04:00`);
      if (selectedDate.getDay() === 0) {
        message.textContent = 'Sundays are unavailable. Please choose Monday–Saturday.';
        dateInput.setCustomValidity('Please choose an available working day.');
        return;
      }
      dateInput.setCustomValidity('');
      const earliest = Date.now() + (24 * 60 * 60 * 1000);
      const available = slots.filter((slot) => new Date(`${dateInput.value}T${slot}:00+04:00`).getTime() >= earliest);
      if (!available.length) {
        message.textContent = 'No time slots remain for this date. Please choose another day.';
        return;
      }
      available.forEach((slot) => {
        const option = document.createElement('option');
        const hour = Number(slot.slice(0, 2));
        const minute = slot.slice(3);
        const displayHour = hour > 12 ? hour - 12 : hour;
        option.value = `${slot} UAE time`;
        option.textContent = `${displayHour}:${minute} ${hour >= 12 ? 'PM' : 'AM'}`;
        timeSelect.appendChild(option);
      });
      timeSelect.disabled = false;
    };
    dateInput.addEventListener('change', refreshTimes);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anc-activities-browser"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-anc-browser]').forEach((root)=>{
  const data=JSON.parse(root.querySelector('[data-activity-data]').textContent);
  const rows=root.querySelector('[data-activity-rows]');
  const search=root.querySelector('[data-activity-search]');
  const category=root.querySelector('[data-category-filter]');
  const regulation=root.querySelector('[data-regulation-filter]');
  const result=root.querySelector('[data-result-count]');
  const empty=root.querySelector('[data-empty-state]');
  const prev=root.querySelector('[data-prev-page]');
  const next=root.querySelector('[data-next-page]');
  const current=root.querySelector('[data-current-page]');
  const total=root.querySelector('[data-total-pages]');
  const pageSize=50;
  let page=1;
  let filtered=data;
  const escapeHtml=(value)=>String(value??'').replace(/[&<>"']/g,(char)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));
  const apply=()=>{
    const query=search.value.trim().toLocaleLowerCase();
    filtered=data.filter((item)=>{
      const haystack=[item.c,item.n,item.g,item.a,item.r,item.p,item.d].join(' ').toLocaleLowerCase();
      return (!query||haystack.includes(query))&&(!category.value||item.g===category.value)&&(!regulation.value||item.r===regulation.value);
    });
    page=1;
    render();
  };
  const render=()=>{
    const pages=Math.max(1,Math.ceil(filtered.length/pageSize));
    page=Math.min(page,pages);
    const start=(page-1)*pageSize;
    rows.innerHTML=filtered.slice(start,start+pageSize).map((item)=>{
      const regulated=item.r==='Regulated';
      const badge=regulated?'aba-badge aba-badge--regulated':'aba-badge aba-badge--non';
      return '<tr><td>'+escapeHtml(item.c)+'</td><td>'+escapeHtml(item.n)+'</td><td>'+escapeHtml(item.g)+'</td><td lang="ar">'+escapeHtml(item.a)+'</td><td><span class="'+badge+'">'+escapeHtml(item.r)+'</span></td><td>'+escapeHtml(item.p)+'</td><td>'+escapeHtml(item.d)+'</td></tr>';
    }).join('');
    result.textContent=filtered.length;
    current.textContent=page;
    total.textContent=pages;
    empty.hidden=filtered.length>0;
    prev.disabled=page<=1;
    next.disabled=page>=pages;
  };
  search.addEventListener('input',apply);
  category.addEventListener('change',apply);
  regulation.addEventListener('change',apply);
  root.querySelector('[data-reset-filters]').addEventListener('click',()=>{search.value='';category.value='';regulation.value='';apply();});
  prev.addEventListener('click',()=>{if(page>1){page--;render();root.querySelector('.aba-panel').scrollIntoView({behavior:'smooth'});}});
  next.addEventListener('click',()=>{if(page<Math.ceil(filtered.length/pageSize)){page++;render();root.querySelector('.aba-panel').scrollIntoView({behavior:'smooth'});}});
  render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
